import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useIcons from '@/composables/useIcons'
  import { useRouter } from 'vue-router/composables'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerQuestionResponseModal',
  props: {
    passed: {
      type: Boolean,
      required: true,
    },
    learningUnitRoute: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
  setup(__props) {

const props = __props;

  
  

  const router = useRouter()
  const { success, thumbsDown } = useIcons()

  const icon = computed((): string => {
    return props.passed ? success.value : thumbsDown.value
  })

  const confirmAction = (passed: boolean) => {
    if (passed) {
      eventBus.$emit('close-modal')
    } else {
      eventBus.$emit('close-modal')
      router.push(props.learningUnitRoute)
    }
  }

return { __sfc: true,props, router, success, thumbsDown, icon, confirmAction, computed, KetchUpButton, useIcons, useRouter, eventBus }
}

})